import React from 'react'

import { useNavigate } from 'react-router-dom'
import { FiAlertTriangle } from 'react-icons/fi'
import Header from '../../components/Header'
import usePersistedState from '../../hooks/usePersistedState'

import { ErroProps } from '../../utils/interfaces'

const Erro: React.FC = () => {
  const [erroProps] = usePersistedState<ErroProps>('erroProps', {} as ErroProps)
  const navigate = useNavigate()

  return (
    <>
      <Header />
      <div className="mx-auto flex h-full max-w-[420px] flex-col items-center pt-[25px] mt-[-25px] min-[766px]:max-w-[500px]">
        <FiAlertTriangle color="#0071BA" size={100} />
        <h2 className="mb-[20px] mt-[20px] text-start text-[#0071ba]">
          {erroProps.title}
        </h2>
        {erroProps.description ? (
          <strong className="mb-[10px] text-start">
            {erroProps.description}
          </strong>
        ) : (
          <></>
        )}
        <button
          type="button"
          onClick={() => navigate(-1)}
          className="mt-[50px] flex flex-col items-center justify-center border-0 border-b border-transparent bg-transparent px-[3px] pb-[2px] text-[#333] hover:border-[#333]"
        >
          &lt; Voltar
        </button>
      </div>
    </>
  )
}

export default Erro
